enum ROUTES {
  INDEX = '/',
  MYACCOUNT_BASE = '/my-account',
  MYACCOUNT_ORDERS = '/my-account/orders',
  MYACCOUNT_RESERVATIONS = '/my-account/reservations',
  MYACCOUNT_ENQUIRY = '/my-account/enquiry',
  MYACCOUNT_PERSONAL_DETAILS = '/my-account/personal-details',
  MYACCOUNT_CHANGE_PASSWORD = '/my-account/change-password',
  MYACCOUNT_FINANCE = '/my-account/finance/*',
  MYACCOUNT_FINANCE_REDIRECTION = '/my-account/finance',
  MYACCOUNT_FINANCE_PERSONAL_DETAILS = '/my-account/finance/personalDetails',
  MYACCOUNT_FINANCE_CREDIT_OPTIONS = '/my-account/finance/credit-options',
  MYACCOUNT_FINANCE_FORM = '/my-account/finance/form',
  MYACCOUNT_FINANCE_CONFIRMATION = '/my-account/finance/confirmation',
  MYACCOUNT_FINANCE_EXTERNAL_FINANCE_APPLICATION = '/my-account/finance/external-finance-application',
  MYACCOUNT_FORGOT_PASSWORD = '/my-account/forgot-password',
  MYACCOUNT_INSURANCE = '/my-account/insurance',
  MYACCOUNT_LOGIN = '/my-account/login',
  CHECKOUT_FINANCE = '/finance-insurance',
  CHECKOUT_YOUR_DETAILS = '/your-details',
  MYACCOUNT_SET_PASSWORD = '/my-account/set-password',
  MYACCOUNT_SAVED_CARS = '/my-account/saved-cars',
  MYACCOUNT_LOGOUT = '/my-account/logout',
  MYACCOUNT_SIGNUP = '/my-account/signup',
}

export default ROUTES
